import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12da0c48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = {
  key: 0,
  class: "view-tenant-review-container"
}
const _hoisted_3 = { class: "review-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title w-100 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Rental History")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-chevron-left" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "d-flex justify-content-center w-100 p-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = { class: "content-tab" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-user d-inline-block icon" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Tenant Report ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-user d-inline-block icon" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Agent Details ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_History = _resolveComponent("History")!
  const _component_BusinessLogo = _resolveComponent("BusinessLogo")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!
  const _component_Report = _resolveComponent("Report")!
  const _component_AgentDetails = _resolveComponent("AgentDetails")!
  const _component_NoReview = _resolveComponent("NoReview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.tenantReviews.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Header, {
            tenant: _ctx.tenantRecord,
            averageRating: _ctx.averageRating,
            tenantReviews: _ctx.tenantReviews,
            class: _normalizeClass({ 'd-none': !_ctx.showingHistory, 'd-block': !_ctx.showingHistory })
          }, null, 8, ["tenant", "averageRating", "tenantReviews", "class"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["review-content-history", { 'd-none': !_ctx.showingHistory, 'd-block': !_ctx.showingHistory }])
            }, [
              _hoisted_4,
              _createVNode(_component_History, {
                tenantReview: _ctx.tenantReview,
                tenantReviews: _ctx.tenantReviews,
                currentTenantReview: _ctx.currentTenantReview,
                loading: _ctx.loading,
                onSelectRentalHistory: _ctx.handleSelectRentalHistory
              }, null, 8, ["tenantReview", "tenantReviews", "currentTenantReview", "loading", "onSelectRentalHistory"])
            ], 2),
            (_ctx.currentTenantReview)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref: "info",
                  class: _normalizeClass(["review-content-inner", { 'd-none': !_ctx.showingInfo, 'd-block': !_ctx.showingInfo }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["title w-100 d-flex align-items-center", {
              'justify-content-center': _ctx.isDesktop,
              'justify-content-between': _ctx.isMobile,
            }]),
                    style: _normalizeStyle(`background:${_ctx.headerColor}!important`)
                  }, [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                      class: "back d-flex align-items-center justify-content-center"
                    }, _hoisted_6),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_BusinessLogo, {
                        imageSrc: _ctx.businessLogoSrc,
                        fill: "scale-down",
                        padding: "0px",
                        height: "25px",
                        fontSize: "14pt",
                        textColor: _ctx.authUser.business_text_color ?? _ctx.defaultTextColor,
                        backgroundColor: _ctx.authUser.business_color ?? _ctx.defaultBGColor,
                        showError: true,
                        errorDefault: "text",
                        errorText: _ctx.$filters.ucwords(_ctx.authUser.business_name)
                      }, null, 8, ["imageSrc", "textColor", "backgroundColor", "errorText"])
                    ]),
                    _hoisted_8
                  ], 6),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["content-tab-item", { active: _ctx.tab == 'report' }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'report'))
                    }, _hoisted_12, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["content-tab-item", { active: _ctx.tab == 'details' }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'details'))
                    }, _hoisted_15, 2)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["map", { 'd-none': _ctx.tab != 'report', 'd-block': _ctx.tab == 'report' }])
                  }, [
                    _createVNode(_component_GMapMap, {
                      center: _ctx.currentCoordinates,
                      options: {
                disableDefaultUI: false,
                draggable: true,
                mapTypeControl: false,
              },
                      zoom: 14,
                      style: {"width":"100%","height":"20rem"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.currentCoordinates], (m, index) => {
                          return (_openBlock(), _createBlock(_component_GMapMarker, {
                            key: index,
                            position: m
                          }, null, 8, ["position"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["center"])
                  ], 2),
                  (_ctx.tab == 'report')
                    ? (_openBlock(), _createBlock(_component_Report, {
                        key: 0,
                        tenantReviews: _ctx.tenantReviews.references,
                        reviewDetailLoading: _ctx.reviewDetailLoading,
                        currentTenantReview: _ctx.tenantReview,
                        "average-rating": _ctx.averageRating
                      }, null, 8, ["tenantReviews", "reviewDetailLoading", "currentTenantReview", "average-rating"]))
                    : _createCommentVNode("", true),
                  (_ctx.tab == 'details')
                    ? (_openBlock(), _createBlock(_component_AgentDetails, {
                        key: 1,
                        currentTenantReview: _ctx.tenantReview
                      }, null, 8, ["currentTenantReview"]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_NoReview, {
          key: 1,
          tenant: _ctx.tenant
        }, null, 8, ["tenant"]))
  ]))
}